export const DEFAULT_CONFIG = {
  logLevel: 'debug',
  cartLocalStorageName: '@metromarkets/shopping-cart',
};

export const CART_SERVICE_INSTANCE_KEY = '@metromarkets/cart';
